import { render, staticRenderFns } from "./ProjectsOverview.vue?vue&type=template&id=b3204bea"
import script from "./ProjectsOverview.vue?vue&type=script&lang=ts"
export * from "./ProjectsOverview.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports